<template>
    <MagTransition name="zoom" appear>
        <div class="mjndxjcg">
            <img
                src="/static-assets/badges/error.png"
                class="_ghost"
                alt="Error"
            />
            <p>
                <mg-icon icon="warning" />
                {{ $t("somethingHappened") }}
            </p>
            <MagButton class="button" @click="() => $emit('retry')">
                {{ $t("retry") }}
            </MagButton>
        </div>
    </MagTransition>
</template>

<script lang="ts" setup>
import { useFluent } from "fluent-vue";

const { $t } = useFluent();
</script>

<style lang="scss" scoped>
.mjndxjcg {
    padding: 32px;
    text-align: center;

    > p {
        margin: 0 0 8px 0;
    }

    > .button {
        margin: 0 auto;
    }

    > img {
        vertical-align: bottom;
        height: 128px;
        margin-bottom: 16px;
        border-radius: 16px;
    }
}
</style>
